import React, { useContext } from 'react';
import { customTravelFormStateAtom } from '@/atoms/customTravelFormState';
import { useAtom } from 'jotai';
import { CustomInitContext } from '@/components/CustomTravel/CustomInit';
import SelectGroupTypeForm from '@/components/CustomTravel/ServiceForm/forms/SelectGroupTypeForm';

interface GroupTypeProps {}

const SelectGroupType: React.FC<GroupTypeProps> = () => {
  const { customOptions } = useContext(CustomInitContext);
  const [{ groupType }] = useAtom(customTravelFormStateAtom);

  const externalValues = groupType && {
    groupType: {
      ...groupType,
      etcName: groupType?.code === 'etc' ? groupType.name : undefined,
    },
  };

  return <SelectGroupTypeForm customOptions={customOptions || []} externalValues={externalValues} />;
};

export default SelectGroupType;
